import Badge from "@/src/components/atom/Badge";
import {
  PlanType,
  SubscriptionStatusType,
} from "@/src/store/apis/subscription/interface";
import { SUBSCRIPTION_STATUS, SUBSCRIPTION_TYPE } from "@/src/constant/login";
import { TFunction } from "i18next";
import styled from "styled-components";

export const renderSubscriptionStatusBadge = (param: {
  t: TFunction;
  type?: PlanType | SubscriptionStatusType | null;
  size?: "S" | "L";
  subscriptionType?: string;
  showFreeBadge?: boolean;
}) => {
  const {
    t,
    type,
    size = "S",
    subscriptionType,
    showFreeBadge = true,
  } = param;

  if (type === null) {
    return;
  }

  // The FINISHED status always shows a gray badge (regardless of FREE type)
  if (type === SUBSCRIPTION_STATUS.FINISHED) {
    return (
      <Badge
        text={t("subscriptionManagement:subscriptionStatus.finished")}
        color="gray4"
        badgeColor="gray10"
        badgeSize={size}
      />
    );
  }

  // Show the free plan badge only when explicitly allowed
  if (showFreeBadge && subscriptionType === SUBSCRIPTION_TYPE.FREE && type === SUBSCRIPTION_STATUS.PROGRESS) {
    return (
      <FreePlanBadge>
        {t("subscriptionManagement:subscriptionStatus.free")}
      </FreePlanBadge>
    );
  }

  switch (type) {
    // PlanType
    case "NORMAL":
      return (
        <Badge
          text={t("subscriptionManagement:subscriptionStatus.normal")}
          color="systemLime1"
          badgeColor="systemLime5"
          badgeSize={size}
        />
      );
    case "ENTERPRISE":
      return (
        <Badge
          text={t("subscriptionManagement:subscriptionStatus.enterprise")}
          color="systemLime1"
          badgeColor="systemLime5"
          badgeSize={size}
        />
      );
    // SubscriptionStatusType
    case SUBSCRIPTION_STATUS.PROGRESS:
      return (
        <Badge
          text={t("subscriptionManagement:subscriptionStatus.progress")}
          color="systemLime1"
          badgeColor="systemLime5"
          badgeSize={size}
        />
      );
    case SUBSCRIPTION_STATUS.CANCELED:
      return (
        <Badge
          text={t("subscriptionManagement:subscriptionStatus.canceled")}
          color="gray4"
          badgeColor="gray10"
          badgeSize={size}
        />
      );
    case SUBSCRIPTION_STATUS.PAYMENT_FAIL:
      return (
        <Badge
          text={t("subscriptionManagement:subscriptionStatus.paymentFail")}
          color="red2"
          badgeColor="red8"
          badgeSize={size}
        />
      );
    case SUBSCRIPTION_STATUS.NOT_PAID_YET:
      return (
        <Badge
          text={t("subscriptionManagement:subscriptionStatus.notPaidYet")}
          color="yellow1"
          badgeColor="yellow6"
          badgeSize={size}
        />
      );

    default:
      return <></>;
  }
};

const FreePlanBadge = styled.div`
  padding: 4px 14px;
  background: #E5F2FF;
  border-radius: 24px;
  justify-content: center;
  align-items: flex-start;
  gap: 6px;
  display: inline-flex;
  
  color: #007AFF;
  font-size: 15px;
  font-family: Pretendard;
  font-weight: 500;
  line-height: 20px;
  word-wrap: break-word;
`;
